import PropTypes from 'prop-types'
import React, { Component } from 'react'

export default class Col extends Component {
  static propTypes = {
    gutters: PropTypes.bool,
    right: PropTypes.bool,
    flex: PropTypes.string,
    margin: PropTypes.number,
    children: PropTypes.any
  }

  render() {
    const { children, gutters, margin, flex, right } = this.props

    let textAlign = 'left'

    textAlign = right && 'right'

    return (
      <div style={{
        flex: flex && flex,
        textAlign,
        margin: gutters ? `0 ${margin}px` : 0
      }}
      >
        {children}
      </div>
    )
  }
}
